import { AxiosResponse } from "axios";
import {
	SubscriptionPackage,
	SubscriptionPackageParams,
} from "features/subscription-class/type";
import { ApiResponse } from "types";
import api from "../apiService";

export const listSubscriptionPackagesAPI = async (
	query: SubscriptionPackageParams,
): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get<
				ApiResponse<SubscriptionPackage[]>
			>("/dashboard/subscription-packages", {
				...query,
				skip: query.skip * (query.take || 10),
			});
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});
export const createSubscriptionPackageAPI = async (
	payload: Partial<SubscriptionPackage>,
): Promise<SubscriptionPackage> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.post<
				ApiResponse<SubscriptionPackage>
			>(`dashboard/subscription-packages`, payload);
			resolve(response.data.data);
		} catch (err) {
			reject(err);
		}
	});

export const updateSubscriptionPackageAPI = async (
	id: string,
	payload: Partial<SubscriptionPackage>,
): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.put<
				ApiResponse<SubscriptionPackage>
			>(`dashboard/subscription-packages/${id}`, payload);
			resolve(response.data.data);
		} catch (err) {
			reject(err);
		}
	});
export const getSubscriptionPackageDetailsAPI = async (
	id?: string,
): Promise<SubscriptionPackage> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get<
				ApiResponse<SubscriptionPackage>
			>(`dashboard/subscription-packages/${id}`);
			resolve(response.data.data);
		} catch (err) {
			reject(err);
		}
	});
